import React from 'react'
import {Link} from 'react-router-dom'
import './adsimple.css'

function Adsimple(props){
  let m1container = 'm1left' ;
  let m1containerImg = 'm1rowImg';

  if(props.picsrc.pic === 'left'){
    m1container = 'm1left container0 border center960';
    m1containerImg = 'm1rowImg';
  }
  if(props.picsrc.pic === 'right'){
    m1container = 'm1right container0 border center960';
    m1containerImg = 'm1rowImg';
  }
  if(props.picsrc.pic === 'top'){
    m1container = 'm1top container0 border center960';
    m1containerImg = 'm1ColumnImg';
  }
  if(props.picsrc.pic === 'bottom'){
    m1container = 'm1bottom container0 border center960';
    m1containerImg = 'm1ColumnImg';
  }

  return (
    <div className={m1container}>
      <div className={m1containerImg}>
        <img className='m1img' src={props.picsrc.picurl} alt="利凯达网络科技" />
      </div>
      <div className='m1desc'>
        <div className='m1topic'>{props.picsrc.topic}</div>
        <div className='m1text'>{props.picsrc.ad}</div>
        <div className='m1text'><Link to={props.link}>查看浏览</Link></div>
      </div>
    </div>
  )
}
   
export default Adsimple
